<template>
    <tr class="c-o-table__tr c-o-table__tr--flip-at-large">
        <td class="c-o-table__td">
            <span v-if="!isDesktop" class="c-o-table__inline-label">Typ:</span>
            <status v-if="company.IsDirect" :status="'direct'">Direkt</status>
            <status v-else :status="'matched'">Matchad</status>
        </td>
        <td class="c-o-table__td">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Företag:</span
            >
            <router-link
                :to="`/hantverkare/${company.CompanyId}/`"
                @click="sendLoading()"
                >{{ company.CompanyName }}</router-link
            >
        </td>
        <td class="c-o-table__td">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >kontaktperson:</span
            >
            <span v-if="company.ContactName">{{ company.ContactName }}</span>
        </td>
        <td class="c-o-table__td">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Telefon:</span
            >
            <a :href="'tel:' + company.ContactPhone">{{
                company.ContactPhone
            }}</a>
        </td>
        <td class="c-o-table__td">
            <span v-if="!isDesktop" class="c-o-table__inline-label">Mail:</span>
            <a :href="'mailto:' + company.ContactEmail">{{
                company.ContactEmail
            }}</a>
        </td>
        <td class="c-o-table__td c-o-table__td--keep-together">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Omdöme:</span
            >
            <router-link
                v-if="company.Rating"
                :to="`/hantverkare/${company.CompanyId}/#ratings`"
            >
                <rating-atom :ratingValue="company.Rating"></rating-atom>
            </router-link>
            <rating-atom v-else></rating-atom>
        </td>
        <td class="c-o-table__td c-o-table__td--keep-together">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Svarstid:</span
            >
            <span v-if="company.AnsweredDate"
                >{{ company.AnsweredDate | formatDateWithMonth }} <br />
                kl {{ company.AnsweredDate | formatTimeWithoutDate }}</span
            >
            <span v-else>Svar saknas</span>
        </td>
        <td
            class="c-o-table__td c-o-table__td--keep-together"
            v-if="company.Emails.length > 0"
        >
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Mailsvar:</span
            >
            <div v-for="email in company.Emails" :key="email.Id">
                <atom-button
                    :label="'Läs'"
                    :icon="'expand'"
                    class="c-a-button--theme-secondary"
                    @buttonClicked="showEmail(email)"
                ></atom-button>
            </div>
            <modal
                class="c-m-modal--small"
                v-if="showModal"
                @close="showModal = false"
            >
                <h1>Meddelande</h1>
                <p
                    class="c-m-modal--small__preline"
                    v-html="currentEmail.Message"
                ></p>
            </modal>
        </td>
    </tr>
</template>
<script>
import AtomButton from "../atoms/AtomButton.vue";
import RatingAtom from "../atoms/AtomRating.vue";
import Filters from "../../../filters/index.js";
import Status from "../atoms/AtomStatus.vue";
import Modal from "../molecules/MoleculeModal.vue";

export default {
    props: {
        company: {
            type: Object
        },
        colspanAll: {
            type: Number
        }
    },
    components: {
        AtomButton,
        RatingAtom,
        Status,
        Modal
    },
    data() {
        return {
            currentEmail: {},
            showModal: false
        };
    },
    filters: Filters,
    methods: {
        showEmail(email) {
            this.currentEmail = email;
            this.showModal = true;
        }
    },
    computed: {
        isDesktop: function() {
            return this.$mq === "xLarge" ? true : false;
        },
        requestId: function() {
            return this.$route.params.id;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeInterestedCompaniesTableRow.vue